import { useEffect, useState } from 'react';
import { api } from '../../api/client';
import type { License } from '../../api/types';
import { Alert, Badge } from '../../components/ui/Badge';
import { Card } from '../../components/ui/Card';
import { formatDateTime, licenseStatusLabel, licenseStatusTone } from '../../utils/format';

export function DevicesPage() {
  const [licenses, setLicenses] = useState<License[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get<License[]>('/api/license/my-licenses')
      .then(setLicenses)
      .catch((err: Error) => setError(err.message));
  }, []);

  return (
    <div>
      <div className="panel-page-header">
        <div>
          <h1 className="page-title">Dispositivos</h1>
          <p className="page-subtitle">
            Estado de activación de cada TPV vinculado a tus licencias.
          </p>
        </div>
      </div>

      {error ? <Alert tone="danger">{error}</Alert> : null}

      <Alert tone="info">
        Para activar: introduce la clave de licencia en Hosty TPV → Configuración → Licencia cloud. Un dispositivo por licencia.
      </Alert>

      <div className="license-grid" style={{ marginTop: '1.5rem' }}>
        {licenses.map((license) => (
          <Card key={license.id} title={license.pos_name || `Licencia #${license.id}`}>
            <div className="stack">
              <div className="license-card__meta">
                <Badge tone={licenseStatusTone(license.status)}>
                  {licenseStatusLabel(license.status)}
                </Badge>
                <span>Clave: {license.license_key}</span>
              </div>
              {license.hardware_id ? (
                <>
                  <p>
                    <strong>Dispositivo activo</strong>
                    <br />
                    <span className="muted">{license.hardware_id}</span>
                  </p>
                  <p className="muted">
                    Activado: {formatDateTime(license.activation_date)}
                  </p>
                </>
              ) : (
                <p className="muted">Pendiente de activación en el TPV con la clave de licencia.</p>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
